import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HelpParagraph = styled.p`
    user-select: none;
`;

const InputCell = styled.form`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
`;

const InputLabel = styled.label`
    margin: 0 0 0.33rem 0;
`;

const ExternalReferenceWorkflowStepTwo = ({
    generateResourceOptions,
    loading,
    onChange,
    specifications,
    selectedSpecification,
    setRenderStep,
    resourceName,
    resourceNameShort,
    ...props
}) => {
    return (
        <div className="modal-content">
            <div className="modal-header">
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">
                    <span id="ext-links-references-add-page-title">
                        Import Existing {resourceName}
                    </span>
                </h4>
            </div>
            <div className="modal-body" style={{ padding: '1.66rem' }}>
                <HelpParagraph>
                    This feature allows you to import {resourceName}s from a
                    different Reporting Specification.
                    <br />
                    Select below the Reporting Specifications from which you
                    would like to import {resourceName}s. Reporting
                    Specifications with no {resourceName}s will not be
                    displayed.
                </HelpParagraph>
                <InputCell>
                    <InputLabel htmlFor="extref-step2-select">
                        <strong>Reporting Specification</strong>
                    </InputLabel>
                    <select
                        id="extref-step2-select"
                        className="form-control"
                        onChange={onChange}
                        value={
                            selectedSpecification !== null
                                ? selectedSpecification
                                : ``
                        }
                    >
                        {Object.keys(specifications).length > 0 ? (
                            <React.Fragment>
                                <option disabled value="">
                                    Select...
                                </option>
                                {Object.keys(specifications).sort((a, b) => {
                                    return specifications[a].name.toLowerCase().localeCompare(specifications[b].name.toLowerCase())
                                }).map((id, k) => (
                                    <option key={k} value={id}>
                                        {specifications[id].name}
                                    </option>
                                ))}
                            </React.Fragment>
                        ) : (
                            <option disabled value="">
                                No reporting specifications available
                            </option>
                        )}
                    </select>
                </InputCell>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => setRenderStep(1)}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        generateResourceOptions().then(() => setRenderStep(3));
                    }}
                    disabled={
                        typeof selectedSpecification === 'undefined' ||
                        selectedSpecification === null ||
                        selectedSpecification === '' ||
                        loading
                    }
                >
                    {loading ? `Loading ${resourceNameShort}s...` : `Continue`}
                </button>
            </div>
        </div>
    );
};

ExternalReferenceWorkflowStepTwo.propTypes = {
    loading: PropTypes.bool,
    generateResourceOptions: PropTypes.func,
    onChange: PropTypes.func,
    setRenderStep: PropTypes.func,
    selectedSpecification: PropTypes.string,
    specifications: PropTypes.object
};

ExternalReferenceWorkflowStepTwo.defaultProps = {
    loading: false,
    generateResourceOptions: () => null,
    onChange: () => null,
    setRenderStep: () => null,
    selectedSpecification: null,
    specifications: []
};

export default ExternalReferenceWorkflowStepTwo;
